module.exports = __webpack_public_path__ + "img/cg.945491f2.svg";